import React from 'react';
import { Form, Typography, Checkbox } from 'antd';
import { Input, Button } from '@gamesb42/ui-kit';

const { Title, Text, Link } = Typography;

interface SignupFormData {
  email: string;
  first_name: string;
  last_name: string;
  company_name: string;
  password: string;
  agree: boolean;
}

interface SignupFormProps {
  form: any;
  loading: boolean;
  onFinish: (values: SignupFormData) => void;
  onLoginClick: () => void;
}

const SignupForm: React.FC<SignupFormProps> = ({ form, loading, onFinish, onLoginClick }) => {
  return (
    <>
      <Title level={2} style={{ marginBottom: '20px', textAlign: 'left' }}>
        Create your account and <span style={{ color: '#5227cb' }}>start earning revenue</span>
      </Title>

      <div style={{ marginBottom: '32px' }}>
        <Text>
          Already registered?{' '}
          <Link
            href="#"
            style={{ color: '#5227cb', textDecoration: 'underline' }}
            onClick={(e) => {
              e.preventDefault();
              onLoginClick();
            }}
          >
            Sign in
          </Link>
        </Text>
      </div>

      <Form form={form} layout="vertical" onFinish={onFinish} size="large">
        <Form.Item
          name="email"
          rules={[
            { required: true, message: 'Please input your email!' },
            { type: 'email', message: 'Please enter a valid email!' },
          ]}
        >
          <Input label="Email" size="large" />
        </Form.Item>

        <Form.Item name="first_name" rules={[{ required: true, message: 'Please input your first name!' }]}>
          <Input label="First Name" size="large" />
        </Form.Item>

        <Form.Item name="last_name" rules={[{ required: true, message: 'Please input your last name!' }]}>
          <Input label="Last Name" size="large" />
        </Form.Item>

        <Form.Item name="company_name" rules={[{ required: true, message: 'Please input your company name!' }]}>
          <Input label="Company Name" size="large" />
        </Form.Item>

        <Form.Item
          name="password"
          rules={[
            { required: true, message: 'Please input your password!' },
            {
              min: 8,
              pattern: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%#?&])[A-Za-z\d@$!%#?&]{8,}$/,
              message: 'Password must be at least 8 characters and contain letters, numbers, and special characters (@$!%#?&)',
            },
          ]}
        >
          <Input label="Password" size="large" type="password" autoComplete="new-password" />
        </Form.Item>

        <Form.Item
          name="agree"
          valuePropName="checked"
          rules={[
            {
              validator: (_, value) =>
                value ? Promise.resolve() : Promise.reject(new Error('You must agree to the terms')),
            },
          ]}
          style={{ marginBottom: '32px' }}
        >
          <Checkbox style={{ alignItems: 'flex-start' }}>
            By clicking the "Create account" button, you are creating a GamesBoost42 account, and you agree to
            GamesBoost42's{' '}
            <Link
              href="https://id.gamesboost42.com/resources/mm3fq/login/factoring/pdf/Terms_of_Service.pdf"
              style={{ color: '#5227cb' }}
            >
              Terms of Service
            </Link>{' '}
            and{' '}
            <Link
              href="https://id.gamesboost42.com/resources/mm3fq/login/factoring/pdf/Privacy_Policy.pdf"
              style={{ color: '#5227cb' }}
            >
              Privacy Policy
            </Link>
          </Checkbox>
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            size="large"
            violet
            style={{
              color: '#fff',
              width: '94px',
            }}
          >
            Submit
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default SignupForm;
